<template>
  <b-row class="home no-gutters">
    <b-col class="tool-border" cols="12">
      <!--header-->
      <b-row class="no-gutters header head-background-gradient">
        <b-col class="head-leftcol" cols="12">
          <div class="main-logo"></div>
        </b-col>

        <b-col class="head-rightcol" cols="12">
          <b-row
            class="heading-row no-gutters"
            :class="{ 'heading-row-sp': $i18n.locale == 'sp' }"
          >
            <b-col class="" cols="12">
              <div
                :class="{ 'headingfont-sp': $i18n.locale == 'sp' }"
                class="main-heading headingfont"
                id="mainHeading"
              >
                {{ $t("home.main-heading") }}
              </div>

              <div
                :class="{ 'sub-heading-sp': $i18n.locale == 'sp' }"
                class="sub-heading"
              >
                {{ $t("home.sub-heading") }}
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="no-gutters body-sec page-background-gradient">
        <b-col class="" cols="12">
          <div
            class="desc-row"
            :class="{ 'desc-row-sp': $i18n.locale == 'sp' }"
          >
            {{ $t("home.desc-row") }}
          </div>
        </b-col>

        <b-col class="" cols="12">
          <div
            :class="{ 'welcome-body-sp': $i18n.locale == 'sp' }"
            class="welcome-body"
          >
            <svg
              class="div-xs-display"
              version="1.1"
              id="Layer_1body"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              style="enable-background: new 0 0 754 329"
              xml:space="preserve"
            >
              <g id="stock-photo-15551842-overweight-male-skeleton.psd_1_">
                <image
                  style="overflow: visible; opacity: 0.5"
                  width="553"
                  height="1400"
                  xlink:href="../images/icon-svg/4F4E5F34.png"
                  transform="matrix(0.24 0 0 0.24 337.44 -4.16)"
                ></image>
                <g>
                  <image
                    style="overflow: visible"
                    width="3750"
                    height="5000"
                    xlink:href="../images/icon-svg/launch_male.png"
                    transform="matrix(6.840000e-02 0 0 6.76000e-02 275.4884 -4.4889)"
                  ></image>
                </g>
              </g>
              <g>
                <g>
                  <line
                    style="fill: none; stroke: #002169; stroke-miterlimit: 10"
                    x1="416.1"
                    y1="76.6"
                    x2="258.7"
                    y2="76.6"
                  />
                  <g>
                    <path
                      style="fill: #002169"
                      d="M415.9,73.8c1.6,0,2.8,1.3,2.8,2.8c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8
										C413.1,75.1,414.4,73.8,415.9,73.8z"
                    />
                  </g>
                </g>
              </g>
              <text
                transform="matrix(1 0 0 1 249.3163 83.3512)"
                text-anchor="end"
                style="
                  fill: #002169;
                  font-family: verdana, serif;
                  font-weight: bold;
                  font-size: 20px;
                "
              >
                {{ $t("home.Hypertension") }}
              </text>
              <g>
                <g>
                  <line
                    style="fill: none; stroke: #002169; stroke-miterlimit: 10"
                    x1="258.7"
                    y1="164.1"
                    x2="403.1"
                    y2="164.1"
                  />
                  <g>
                    <path
                      style="fill: #002169"
                      d="M402.9,166.9c1.6,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8c-1.6,0-2.8,1.3-2.8,2.8
										S401.4,166.9,402.9,166.9z"
                    />
                  </g>
                </g>
              </g>
              <text transform="matrix(1 0 0 1 169 169.9116)" text-anchor="end">
                <tspan
                  x="80.6"
                  y="0"
                  style="
                    fill: #002169;
                    font-family: verdana, serif;
                    font-weight: bold;
                    font-size: 20px;
                  "
                  text-anchor="end"
                >
                {{ $t("home.Infertility") }}
                </tspan>
              </text>
              <g>
                <g>
                  <line
                    style="fill: none; stroke: #002169; stroke-miterlimit: 10"
                    x1="257.7"
                    y1="121.1"
                    x2="388.1"
                    y2="121.1"
                  />
                  <g>
                    <path
                      style="fill: #002169"
                      d="M387.9,123.9c1.6,0,2.8-1.3,2.8-2.8c0-1.6-1.3-2.8-2.8-2.8c-1.6,0-2.8,1.3-2.8,2.8
										C385.1,122.7,386.4,123.9,387.9,123.9z"
                    />
                  </g>
                </g>
              </g>
              <text
                transform="matrix(1 0 0 1 561.4579 102.3512)"
                style="
                  fill: #002169;
                  font-family: verdana, serif;
                  font-weight: bold;
                  font-size: 20px;
                "
              >
                {{ $t("home.Dyslipidemia") }}
              </text>
              <text
                transform="matrix(1 0 0 1 249.4 126.9116)"
                text-anchor="end"
                style="
                  fill: #002169;
                  font-family: verdana, serif;
                  font-weight: bold;
                  font-size: 20px;
                "
              >
                {{ $t("home.diabetes") }}
              </text>
              <g>
                <g>
                  <line
                    style="fill: none; stroke: #002169; stroke-miterlimit: 10"
                    x1="256.7"
                    y1="243.1"
                    x2="381.1"
                    y2="243.1"
                  />
                  <g>
                    <path
                      style="fill: #002169"
                      d="M380.9,245.9c1.6,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8c-1.6,0-2.8,1.3-2.8,2.8
										S379.4,245.9,380.9,245.9z"
                    />
                  </g>
                </g>
              </g>
              <text
                transform="matrix(1 0 0 1 247.5976 248.9116)"
                text-anchor="end"
                style="
                  fill: #002169;
                  font-family: verdana, serif;
                  font-weight: bold;
                  font-size: 20px;
                "
              >
                {{ $t("home.Osteoarthritis") }}
              </text>
              <polyline
                style="fill: none; stroke: #11a5de; stroke-miterlimit: 10"
                points="471.7,5.6 504.7,5.6 504.7,322.6 472.7,322.6 "
              />
              <g>
                <g>
                  <g>
                    <line
                      style="fill: none; stroke: #002169; stroke-miterlimit: 10"
                      x1="504.4"
                      y1="140.6"
                      x2="551.7"
                      y2="140.6"
                    />
                    <g>
                      <path
                        style="fill: #002169"
                        d="M504.6,143.4c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8c1.6,0,2.8,1.3,2.8,2.8
											S506.1,143.4,504.6,143.4z"
                      />
                    </g>
                  </g>
                </g>
                <text
                  transform="matrix(1 0 0 1 561.4579 147.3512)"
                  style="
                    fill: #002169;
                    font-family: verdana, serif;
                    font-weight: bold;
                    font-size: 20px;
                  "
                >
                  {{ $t("home.Cancer") }}
                </text>
                <g>
                  <g>
                    <line
                      style="fill: none; stroke: #002169; stroke-miterlimit: 10"
                      x1="504.4"
                      y1="185.6"
                      x2="551.7"
                      y2="185.6"
                    />
                    <g>
                      <path
                        style="fill: #002169"
                        d="M504.6,188.4c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8c1.6,0,2.8,1.3,2.8,2.8
											S506.1,188.4,504.6,188.4z"
                      />
                    </g>
                  </g>
                </g>
                <text
                  transform="matrix(1 0 0 1 561.4579 192.3512)"
                  style="
                    fill: #002169;
                    font-family: verdana, serif;
                    font-weight: bold;
                    font-size: 20px;
                  "
                >
                  {{ $t("home.lifeLost") }}
                </text>
              </g>
              <g>
                <g>
                  <line
                    style="fill: none; stroke: #002169; stroke-miterlimit: 10"
                    x1="416.7"
                    y1="93.8"
                    x2="551"
                    y2="93.8"
                  />
                  <g>
                    <circle
                      style="fill: #002169"
                      cx="416.8"
                      cy="93.8"
                      r="2.8"
                    />
                  </g>
                </g>
              </g>
            </svg>

            <div class="div-xs-hide">
              <ul>
                <li>{{ $t("home.Hypertension") }}</li>
                <li>{{ $t("home.diabetes") }}</li>
                <li>{{ $t("home.Infertility") }}</li>
                <li>{{ $t("home.Osteoarthritis") }}</li>
                <li>{{ $t("home.Dyslipidemia") }}</li>
                <li>{{ $t("home.Cancer") }}</li>
                <li>{{ $t("home.lifeLost") }}</li>
              </ul>
            </div>
          </div>
        </b-col>

        <b-col class="" cols="12">
          <b-row class="no-gutters footer-sec">
            <b-col class="" cols="12">
              <b-row class="no-gutters">
                <b-col class="div-lg" lg="4" cols="12">
                  <div class="privacy-div">
                    <a
                      class="privacy"
                      href="https://www.novonordisk-us.com/privacy-notice.html#info"
                      target="_blank"
                      >{{ $t("home.privacy") }}</a
                    >
                  </div>
                </b-col>

                <b-col lg="4" cols="12">
                  <b-col cols="12">
                    <router-link
                      :class="{ 'getstarted-btn-sp': $i18n.locale == 'sp' }"
                      class="getstarted-btn"
                      :to="{ path: '/intendedUse' }"
                      exact
                    >
                    </router-link>
                  </b-col>
                </b-col>

                <b-col class="div-sm" lg="4" cols="12">
                  <div class="privacy-div">
                    <a
                      class="privacy"
                      href="https://www.novonordisk-us.com/privacy-notice.html#info"
                      target="_blank"
                      >{{ $t("home.privacy") }}</a
                    >
                  </div>
                </b-col>

                <b-col lg="4" cols="12">
                  <div
                    class="copyrights"
                    :class="{ 'copyrights-sp': $i18n.locale == 'sp' }"
                  >
                    © {{ CurrYear }} Novo Nordisk<span
                      class="double-spacing"
                    ></span
                    >All rights reserved. {{ $t("home.copyright1")
                    }}
                    <span v-if="$i18n.locale == 'en'"
                      >{{ CurrMonth }} {{ CurrYear }}</span
                    >
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
/* eslint-disable */
import scrollMixin from "../mixins/scrollMixin";

export default {
  name: "home",
  mixins: [scrollMixin],
  mounted: function () {
    this.setsize();
    this.scrollToTop();
    const month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date();
    this.CurrMonth = "October"; /////////// month[d.getMonth()];
    this.CurrYear = d.getFullYear();
  },

  components: {},

  methods: {
    setsize: function () {
      var mySVG = document.getElementById("Layer_1body");
      const iSize = parseInt(this.$t("home.imagesize"));
      mySVG.setAttribute("viewBox", "32 0 " + iSize + " 329");
      console.log(
        "locale:" +
          this.$i18n.locale +
          " - heading font: " +
          this.$t("home.headingsize")
      );
    },
  },

  data() {
    return {
      CurrYear: 2022,
      CurrMonth: "June",
    };
  },
};
</script>


<style lang="scss" scoped>
</style>
